<template>
  <div class="components-my-editor">
    <div ref="myEditorNav" class="myEditorNav" name="n_my_editor_nav"></div>
    <div ref="myEditor" class="myEditorConten"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
import ossUpload from '../mixins/ossUpload'
export default {
  name: 'MyEditor',
  mixins: [ossUpload],
  props: {
    content: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      editor: null,
      editorHasReady: false
    }
  },
  created() {
    //触发获取OSS服务器的token（文件上传）
    this.listenerFunction()
  },
  computed: {
    editorConfig() {
      var option = {}
      for (let key in this.config) {
        option[key] = this.config[key]
      }
      option.lang = 'zh-cn'
      return option
    }
  },
  watch: {
    content: function() {
      this.contentUpdate()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.editor = new E(this.$refs.myEditorNav, this.$refs.myEditor) // 初始化UE

      // 配置菜单
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'video', // 插入视频
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]
      this.editor.customConfig.colors = [
        '#ffffff',
        '#000000',
        '#333333',
        '#666666',
        '#999999',
        '#AAAAAA',

        '#19AF54',
        '#93CE58',
        '#1EB1ED',
        '#1072BD',
        '#03225E',
        '#6F359E',
        '#BE0712',
        '#FC0D1B',
        '#FDBF2E',
        '#FFFD38',
        '#455469'
      ]

      this.editor.customConfig.onchange = html => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('update:content', this.info_) // 将内容同步到父组件中
      }

      this.editor.customConfig.customUploadImg = this.customUploadImg

      // 创建富文本编辑器
      this.editor.create()

      this.editor.txt.html(this.content)
      if (!this.isEdit) {
        this.editor.$textElem.attr('contenteditable', false)
      }
    },
    contentUpdate(content) {
      this.editor.txt.html(content)
    },
    /**
     * 自定义上传图片事件
     * */
    customUploadImg(files, insert) {
      // files 是 input 中选中的文件列表
      // insert 是获取图片 url 后，插入到编辑器的方法
      // 上传代码返回结果之后，将图片插入到编辑器中
      if (files.length === 0) {
        return
      }
      for (let i = 0; i < files.length; i++) {
        // 上传图片回调 insert
        let index = i
        this.ossUpload(files[index])
          .then(res => {
            insert(res.url)
          })
          .catch(() => {
            this.$message.error('上传文件失败！')
          })
      }
    },
    getContent() {
      // 获取内容方法
      if (this.editor) {
        return this.editor.getContent()
      }
      return ''
    },
    setContent(Msg) {
      var timer
      if (!this.editorHasReady) {
        timer = setInterval(() => {
          this.editor.setContent(Msg)
          clearInterval(timer)
        }, 50)
        return
      }
      this.editor.setContent(Msg)
    },
    destroy() {
      this.editor.destroy()
      this.editor = undefined
    },
    /**
     * 事件监听
     */
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    handleScroll() {
      let ele = document.getElementsByClassName('page-router-wrapper')[0]
      let editorNav = document.getElementsByName('n_my_editor_nav')[0]
      // if (ele.scrollTop > 100 && editorNav) {
      //   editorNav.classList.add('suspension')
      // } else {
      //   editorNav.classList.remove('suspension')
      // }
    }
  },
  /**
   * 销毁事件监听
   */
  beforeDestroy() {
    document.removeEventListener('scroll', this.listenerFunction)
  },
  destroyed() {
    if (this.editorHasReady && this.editor) {
      this.editor.destroy()
    }
  }
}
</script>

<style lang="scss" scoped>
.components-my-editor {
  height: calc(100% - 50px);
  border: 1px solid #eee;
  .myEditorConten {
    height: calc(100% - 60px);
  }
  .myEditorNav {
    border-bottom: 1px solid #eee;
  }
  .suspension {
    top: 66px;
    // top: 106px;
    z-index: 99999;
    position: fixed;
    width: 879px;
    border-top: 1px solid #eee;
    background-color: #f0f2f5;
  }
}
</style>
<style lang="scss">
.components-my-editor {
  .myEditorConten {
    .w-e-text {
      overflow-y: unset !important;
      min-height: 200px;
      p {
        line-height: 20px !important;
        margin: unset !important;
      }
    }
  }
}
</style>
